/** True only on list pages that own an import header toggle. */
export function isImportQueueHeaderRoute(pathname: string): boolean {
  return (
    pathname === '/insights' ||
    pathname === '/templates' ||
    pathname === '/listings'
  );
}
